module.exports = __webpack_public_path__ + "img/index-banner-1-main.0f7368d7.png";